export { PressReleaseCollection } from '@/components/common/PressReleaseCollection/PressReleaseCollection';
